import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle, Download, WhatsappLogo } from "@phosphor-icons/react";
import { siteSettings } from "@/content/site";

export default function GrazieGuida() {
  const wa = siteSettings.whatsapp_number?.replace(/[^\d]/g, "");
  const pdf = siteSettings.guida_pdf_url;

  return (
    <div className="min-h-screen bg-warm-white flex items-center justify-center px-5">
      <div className="max-w-xl text-center">
        <CheckCircle size={64} weight="light" className="text-oasi-green mx-auto mb-6" />
        <div className="overline mb-3">Richiesta ricevuta</div>
        <h1 className="font-display text-4xl md:text-5xl mb-5">Grazie, richiesta ricevuta.</h1>
        <p className="text-[#5C5C59] text-base md:text-lg leading-relaxed mb-8">Ti invieremo la guida gratuita Oasi Bagni il prima possibile. Se vuoi fare un passo in più, puoi richiedere un sopralluogo gratuito.</p>
        <div className="flex flex-col gap-3 justify-center">
          {pdf ? (
            <a href={pdf} target="_blank" rel="noopener noreferrer" className="btn-primary inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full text-sm" data-testid="grazie-guida-download">
              <Download size={18} /> Scarica la guida
            </a>
          ) : (
            <div className="text-xs text-[#5C5C59] italic">La guida verrà inviata via email il prima possibile.</div>
          )}
          <Link to="/prenota-sopralluogo" className="btn-outline inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full text-sm">
            Richiedi sopralluogo gratuito <ArrowRight size={16} />
          </Link>
          {wa && (
            <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 text-sm text-oasi-green underline py-2">
              <WhatsappLogo size={16} weight="fill" /> Scrivici su WhatsApp
            </a>
          )}
        </div>
        <Link to="/" className="block mt-8 text-xs text-[#5C5C59] underline">Torna alla homepage</Link>
      </div>
    </div>
  );
}
